import React, { useEffect } from 'react'
import styled from 'styled-components'
import useDFPSlot from '@/hooks/useDFPSlot'

const Ad = styled.div`
  margin: 0 auto;
  background-color: #fff;
  padding-top: 1rem;
  padding-bottom: 1rem;
  > div {
    width: 300px;
    height: 600px;
    margin: 1rem auto;
    overflow: hidden;
    @media (orientation: portrait) {
      width: 300px;
      height: 250px;
    }
  }
`
const AdComponent = ({ adid, slug }) => {
  useDFPSlot({
    path: `/124506296/Especiales/Especial_RankingUniversidades_LT/${slug}_300x600`,
    sizes: [
      [300, 250],
      [300, 600],
    ],
    id: `${adid}`,
    category: slug,
  })

  return (
    <div className="z-10 m-2 mt-16">
      <Ad>
        <span className="block -mt-3 text-xs leading-none text-center text-gray-400">
          publicidad
        </span>

        <div id={adid} />
      </Ad>
    </div>
  )
}

export default AdComponent
